import { createContext, useContext } from "react";
import { Chapter } from "./components/common";

export const LangContext = createContext({ lang: "en", setLang: () => {} });
export const useLang = () => useContext(LangContext);

const STR = {
  en: {
    nav_focus: "Focus", nav_publications: "Publications", nav_journey: "Journey",
    nav_chunav: "CHUNAV AI", nav_honours: "Honours", nav_connect: "Connect",
    nav_cta: "Prototype Demo", nav_brand_role: "Psephologist · BHU",
    hero_status: "Post-Doctoral Fellow · Political Science",
    hero_name_1: "Dr. Abhishek", hero_name_2: "Verma",
    hero_line_1: "Decoding Electoral", hero_line_2: "Behaviour Through", hero_line_3: "Data & Psephology",
    hero_sub_a: "Pioneer of the ",
    hero_sub_b: " voting system — mapping India's electoral behaviour with big data, from the Faculty of Social Sciences at ",
    hero_sub_c: ".",
    hero_explore: "Explore Research", hero_cv: "Download CV",
    hero_location: "Varanasi · Uttar Pradesh · India",
    c1_kicker: "Research Focus", c1_title: "Empirical election science, measured in output",
    c2_kicker: "Publication Archive", c2_title: "Twenty-six works across journals, chapters & books",
    c3_kicker: "Academic Journey", c3_title: "From Bodh Gaya classrooms to the BHU faculty",
    c4_kicker: "Patents & Innovation", c4_title: "CHUNAV — Citizens Help Using Navigational AI in Voting",
    c5_kicker: "Honours & Service", c5_title: "Recognition across research, teaching & society",
    c6_kicker: "Connect", c6_title: "Collaborations, commentary & guest lectures",
    chart_output: "Scholarly output by year", chart_index: "Indexation split", chart_areas: "Research footprint",
    filter_all: "All", filter_journals: "Journal Articles", filter_chapters: "Book Chapters", filter_books: "Books",
    search_placeholder: "Search title or venue…", pubs_empty: "No publications match your search.",
    journey_career: "Appointments", journey_education: "Education",
    chunav_cta: "Explore live prototype", chunav_caption: "Working demo of the voter-behaviour analysis prototype",
    panel_review: "Peer Review & Editorial", panel_affil: "Professional Affiliations", panel_certs: "Certifications",
    form_kicker: "Direct Uplink", form_title: "Send a message straight to my inbox",
    form_name: "> your_name", form_email: "> your_email",
    form_message: "> compose_message — collaboration, lecture invite, media query…",
    form_submit: "Transmit Message", form_sending: "Transmitting…",
    form_toast_ok: "Transmission received", form_toast_ok_d: "Your message has been emailed to Dr. Verma's inbox.",
    form_toast_err: "Transmission failed", form_toast_err_d: "Please use the direct email links below instead.",
    contact_intro: "Open to research collaboration, election consulting, media commentary on Indian electoral politics, and invited lectures on psephology, governance and AI-driven voter analytics.",
    label_email_1: "Primary Email", label_email_2: "Alternate Email", label_phone: "Phone / WhatsApp", label_web: "Web",
    label_address: "Institutional Address", label_profiles: "Verified Scholar Profiles",
    footer_rights: "© 2026 Dr. Abhishek Verma · Psephology & Electoral Behaviour · Varanasi, India",
  },
  hi: {
    nav_focus: "फ़ोकस", nav_publications: "प्रकाशन", nav_journey: "यात्रा",
    nav_chunav: "CHUNAV AI", nav_honours: "सम्मान", nav_connect: "संपर्क",
    nav_cta: "प्रोटोटाइप डेमो", nav_brand_role: "मतदानशास्त्री · BHU",
    hero_status: "पोस्ट-डॉक्टरल फेलो · राजनीति विज्ञान",
    hero_name_1: "डॉ. अभिषेक", hero_name_2: "वर्मा",
    hero_line_1: "चुनावी व्यवहार का", hero_line_2: "डेटा विज्ञान एवं", hero_line_3: "मतदानशास्त्र से विश्लेषण",
    hero_sub_a: "",
    hero_sub_b: " मतदान प्रणाली के जनक — बिग डेटा से भारत के चुनावी व्यवहार का मानचित्रण, ",
    hero_sub_c: " के सामाजिक विज्ञान संकाय में।",
    hero_explore: "शोध देखें", hero_cv: "CV डाउनलोड करें",
    hero_location: "वाराणसी · उत्तर प्रदेश · भारत",
    c1_kicker: "शोध फ़ोकस", c1_title: "आनुभविक चुनाव विज्ञान — आँकड़ों में मापा हुआ",
    c2_kicker: "प्रकाशन संग्रह", c2_title: "पत्रिकाओं, अध्यायों और पुस्तकों में 26 कृतियाँ",
    c3_kicker: "शैक्षणिक यात्रा", c3_title: "बोधगया की कक्षाओं से बीएचयू तक",
    c4_kicker: "पेटेंट और नवाचार", c4_title: "CHUNAV — मतदान में नेविगेशनल AI",
    c5_kicker: "सम्मान और सेवा", c5_title: "शोध, शिक्षण और समाज में पहचान",
    c6_kicker: "संपर्क", c6_title: "सहयोग, टिप्पणी और अतिथि व्याख्यान",
    chart_output: "वर्षवार शैक्षणिक आउटपुट", chart_index: "अनुक्रमण विभाजन", chart_areas: "शोध क्षेत्र",
    filter_all: "सभी", filter_journals: "पत्रिका लेख", filter_chapters: "पुस्तक अध्याय", filter_books: "पुस्तकें",
    search_placeholder: "शीर्षक या पत्रिका खोजें…", pubs_empty: "आपकी खोज से कोई प्रकाशन नहीं मिला।",
    journey_career: "नियुक्तियाँ", journey_education: "शिक्षा",
    chunav_cta: "लाइव प्रोटोटाइप देखें", chunav_caption: "मतदाता-व्यवहार विश्लेषण प्रोटोटाइप का कार्यशील डेमो",
    panel_review: "सहकर्मी समीक्षा और संपादन", panel_affil: "पेशेवर सदस्यताएँ", panel_certs: "प्रमाणपत्र",
    form_kicker: "सीधा संपर्क", form_title: "संदेश सीधे मेरे इनबॉक्स में भेजें",
    form_name: "> आपका_नाम", form_email: "> आपका_ईमेल",
    form_message: "> संदेश_लिखें — सहयोग, व्याख्यान निमंत्रण, मीडिया प्रश्न…",
    form_submit: "संदेश भेजें", form_sending: "भेजा जा रहा है…",
    form_toast_ok: "संदेश प्राप्त हुआ", form_toast_ok_d: "आपका संदेश डॉ. वर्मा के इनबॉक्स में भेज दिया गया है।",
    form_toast_err: "संदेश विफल", form_toast_err_d: "कृपया नीचे दिए सीधे ईमेल लिंक का उपयोग करें।",
    contact_intro: "शोध सहयोग, चुनाव परामर्श, भारतीय चुनावी राजनीति पर मीडिया टिप्पणी, तथा मतदानशास्त्र, शासन और AI-चालित मतदाता विश्लेषण पर आमंत्रित व्याख्यान हेतु खुला।",
    label_email_1: "प्राथमिक ईमेल", label_email_2: "वैकल्पिक ईमेल", label_phone: "फ़ोन / व्हाट्सऐप", label_web: "वेब",
    label_address: "संस्थागत पता", label_profiles: "सत्यापित विद्वान प्रोफ़ाइल",
    footer_rights: "© 2026 डॉ. अभिषेक वर्मा · मतदानशास्त्र एवं चुनावी व्यवहार · वाराणसी, भारत",
  },
};

export const t = (lang, key) => STR[lang]?.[key] ?? STR.en[key] ?? key;

export const TChapter = ({ num, k, dark = false }) => {
  const { lang } = useLang();
  return <Chapter num={num} kicker={t(lang, `${k}_kicker`)} title={t(lang, `${k}_title`)} dark={dark} />;
};

export const MARQUEE_HI = [
  "मतदानशास्त्र", "चुनावी व्यवहार", "बनारस हिन्दू विश्वविद्यालय", "CHUNAV AI मतदान प्रणाली",
  "भारतीय चुनाव", "राजनीति में डेटा विज्ञान", "SCOPUS अनुक्रमित", "ELECTBHARAT.COM",
  "गठबंधन राजनीति", "जन नीति",
];
